import './WhoItsFor.css'

const audiences = [
  {
    title: 'SMEs',
    description: "You're running a real business. You need real tools — not duct-taped together, but designed to work as one.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M3 21h18M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16"/>
      </svg>
    ),
    gradient: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)',
  },
  {
    title: 'Startups',
    description: "Start with payments. Add accounting when finances get complex. Add infrastructure when you're ready to scale.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M23 6l-9.5 9.5-5-5L1 18"/>
        <path d="M17 6h6v6"/>
      </svg>
    ),
    gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
  },
  {
    title: 'E-commerce',
    description: 'Selling online means managing transactions, taxes, and sometimes hosting. Hubthrill keeps it all under one roof.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="9" cy="21" r="1"/>
        <circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>
      </svg>
    ),
    gradient: 'linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)',
  },
  {
    title: 'Developers',
    description: 'APIs for everything. No vendor lock-in patterns. Build on Hubthrill or integrate it into what you already have.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polyline points="16 18 22 12 16 6"/>
        <polyline points="8 6 2 12 8 18"/>
      </svg>
    ),
    gradient: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
  },
]

function WhoItsFor() {
  return (
    <section className="who-its-for section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Built for</span>
          <h2 className="section-title">
            For businesses that want<br />
            <span className="gradient-text">focus, not fragmentation.</span>
          </h2>
        </div>

        <div className="audiences-grid">
          {audiences.map((audience, index) => (
            <div key={index} className="audience-card">
              <div className="audience-icon" style={{ background: audience.gradient }}>
                {audience.icon}
              </div>
              <h3 className="audience-title">{audience.title}</h3>
              <p className="audience-description">{audience.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhoItsFor
